export const DEAL_TYPES = { credit: "Crédit", assurance: "Assurance", placement: "Placement" };
export const DEAL_STAGES = {
  prospect: { label: "Prospect", cls: "bg-slate-100 text-slate-700" },
  etude: { label: "En étude", cls: "bg-blue-50 text-blue-700" },
  proposition: { label: "Proposition envoyée", cls: "bg-amber-50 text-amber-700" },
  signee: { label: "Signée", cls: "bg-emerald-50 text-emerald-700" },
  perdue: { label: "Perdue", cls: "bg-red-50 text-red-700" },
};
export const OPEN_STAGES = ["prospect", "etude", "proposition"];

export const parisToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/Paris" });
export const isDue = (d) => OPEN_STAGES.includes(d.stage) && d.next_followup && d.next_followup <= parisToday();
export const eur = (n) => (n == null || n === "" ? "—" : Number(n).toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }));
export const frDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—");
